import { ApiClient } from './ApiClient';
import {
  GroupTracker,
  GroupTrackerAttributes,
  GroupTrackerCreationAttributes,
  GroupTrackerUpdateAttributes,
} from '~/models/GroupTracker';

export default class GroupTrackerApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/group-trackers';

  public async cloneGroupTracker(trackerId: number, allowRestoreToTemplate: boolean): Promise<GroupTracker> {
    const response = await this.post(`${this.BASE_URL}/clone`, { trackerId, allowRestoreToTemplate });

    return new GroupTracker(response.data);
  }

  public async provideGroupTrackers(softwareId: number): Promise<GroupTracker[]> {
    const response = await this.get(`${this.BASE_URL}?softwareId=${softwareId}`);
    return response.data.map((attributes: GroupTrackerAttributes) => new GroupTracker(attributes));
  }

  public async provideGroupTracker(trackerId: number): Promise<GroupTracker> {
    const response = await this.get(`${this.BASE_URL}/${trackerId}`);
    return new GroupTracker(response.data);
  }

  public async provideAssignedGroups(trackerId: number): Promise<GroupTracker[]> {
    const response = await this.get(`${this.BASE_URL}/assigned/${trackerId}`);
    return response.data.length ? response.data.map((attributes: GroupTrackerAttributes) => new GroupTracker(attributes)) : [];
  }

  public async provideGroupTrackerById(trackerId: number): Promise<GroupTracker> {
    const response = await this.get(`${this.BASE_URL}/by-id/${trackerId}`);
    return new GroupTracker(response.data);
  }

  public async createGroupTracker(attributes: GroupTrackerCreationAttributes) {
    return this.post(this.BASE_URL, attributes);
  }

  public async updateGroupTracker(attributes: GroupTrackerUpdateAttributes) {
    const response = await this.patch(this.BASE_URL, attributes);
    return new GroupTracker(response.data);
  }
}
